const faqs = [
  {
    q: '91黑料网是什么类型的网站？',
    a: '91黑料网是国内领先的黑料视频聚合与资讯内容平台，每日更新最新黑料短视频，提供91黑料视频合集在线观看服务，内容涵盖娱乐圈、网红圈、体育圈、科技圈、直播圈等多个领域。',
  },
  {
    q: '网站的黑料视频内容是免费观看的吗？',
    a: '是的，91黑料网所有黑料视频内容均免费在线观看，无需注册或付费。您可以直接访问网站浏览最新的黑料视频合集，享受流畅的在线播放体验。',
  },
  {
    q: '黑料视频的更新频率是怎样的？',
    a: '91黑料网坚持每日更新，运营团队全天候追踪最新黑料动态，确保您每天打开网站都能看到新鲜的黑料短视频内容。遇到重大爆料事件时，平台会第一时间跟进报道。',
  },
  {
    q: '如何向91黑料网投稿爆料？',
    a: '您可以通过网站首页的"投稿爆料"栏目获取我们的联系邮箱和微信，将您掌握的爆料线索或黑料素材发送给我们。所有投稿信息将被严格保密，经核实后由专业团队制作发布。',
  },
  {
    q: '移动端有专门的APP吗？',
    a: '91黑料网已推出专属移动端应用，支持随时随地流畅观看黑料视频。您可以在首页"移动端"区域获取详细入口信息，手机观看体验与电脑端同样流畅出色。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">关于91黑料网的使用与黑料视频观看，您想了解的都在这</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm font-bold text-foreground-800 pr-4">{faq.q}</h3>
                <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0" />
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0" />
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}